// Timing utilities for runtime compile diagnostics.
// Provides high-resolution now helper and readable duration formatter.

// High-resolution now helper with Date fallback.
export function getNow(): number {
  // Prefer high-resolution timer when Performance API is available.
  if (typeof performance !== "undefined" && typeof performance.now === "function") {
    // Return high-resolution timestamp.
    return performance.now();
  }

  // Return fallback timestamp when Performance API is unavailable.
  return Date.now();
}

// Format compile duration for concise diagnostics.
export function formatDuration(durationMs: number): string {
  // Guard against invalid timing results.
  if (!Number.isFinite(durationMs)) {
    // Return default value for invalid durations.
    return "0 ms";
  } else {
    // Continue precision selection for valid values.
  }

  // Keep sub-millisecond precision readable.
  if (durationMs < 1) {
    // Return 3-decimal precision for very small durations.
    return `${durationMs.toFixed(3)} ms`;
  } else if (durationMs < 10) {
    // Use 2 decimals for small durations.
    return `${durationMs.toFixed(2)} ms`;
  } else {
    // Return 1-decimal precision for larger durations.
    return `${durationMs.toFixed(1)} ms`;
  }
}
